import { autobind } from "@typed-decorators/autobind";
import { Component } from "react";

import { client } from "../../utils/kibelaClient2";
import type { RelayId } from "../../utils/relay";

import { HoverPopover } from "./HoverPopover";
import { ProfilePopup } from "./profile/ProfilePopup";
import type { SizeType } from "./UserAvatar";
import { UserAvatar } from "./UserAvatar";

import type { UserAvatarWithPopupQuery } from "~/client/generated/schema";
import { UserAvatarWithPopupDocument } from "~/client/generated/schema";

export interface UserType {
  id: RelayId;
  account: string;
  avatar1x: {
    url: string;
  };
  avatar2x: {
    url: string;
  };
}

interface Props {
  user: UserType;
  size: SizeType;
  isLink?: boolean;
}

interface State {
  user: UserAvatarWithPopupQuery["user"] | null;
}

export class UserAvatarWithPopup extends Component<Props, State> {
  static readonly defaultProps = {
    isLink: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      user: null,
    };
  }

  @autobind
  async handleMouseEnter() {
    if (!this.state.user) {
      const { data } = await client.query<UserAvatarWithPopupQuery>({
        query: UserAvatarWithPopupDocument,
        variables: { userId: this.props.user.id },
      });
      this.setState({ user: data.user });
    }
  }

  render() {
    return (
      <div className={`profilePopup-container is-${this.props.size}`}>
        <HoverPopover
          onBeforeShow={this.handleMouseEnter}
          width={"240px"}
          panel={this.state.user && <ProfilePopup user={this.state.user} />}
        >
          <UserAvatar user={this.props.user} size={this.props.size} isLink={this.props.isLink} />
        </HoverPopover>
      </div>
    );
  }
}
